export default "__VITE_ASSET__eDB7dXgN__"